export default "__VITE_ASSET__cb6efab6__"